const validateEmail = (val) => {
  if (!val || val.length < 1) { return 'Invalid email.' }
  if (!/^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/.test(val)) { return 'Email not valid.' }
}
const validatePassword = (val) => {
  if (!val || val.length < 1) { return 'Password required.' }
  if (val.length < 6) { return '6 characters minimum.' }
}
const required = (val) => {
  if ([null, undefined].includes(val) || val.length < 1) { return 'Dies ist ein Pflichtfeld.' }
}

const otpToken = (val) => {
  if (!val || val.length < 6) { return 'The token has to be 6 characters long.' }
  if (!/^\d+$/.test(val)) { return 'Please enter a valid number.' }
}

const nameValidation = (val) => {
  if (!val || val.length < 2) { return 'Dies ist ein Pflichtfeld.' }
}

export function useValidations () {
  return {
    validateEmail,
    validatePassword,
    required,
    otpToken,
    nameValidation
  }
}
